import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const WhatsappMetaAppsHome = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-provider-apps'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'whatsapp_meta_apps_list',
          component: WhatsappMetaAppsHome,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
